import { Navigate } from 'react-router-dom'

import { RedirectToFolderSettingsPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

const RedirectToFolderSettingsPage = () => {
  const { navigation } = useNavigation()
  const { data, loading } = useQuery(RedirectToFolderSettingsPageDocument, {})

  const routes = [
    {
      condition: () => data?.documents?._policies?.companyManagePublicCompanyFolders.can,
      path: navigation.settings.folders.public.fullPath(),
    },
    {
      condition: () => data?.documents?._policies?.companyManageFolders.can,
      path: navigation.settings.folders.internal.fullPath(),
    },
    {
      condition: () => data?.documents?._policies?.companyManageEmployeesFolders.can,
      path: navigation.settings.folders.employees.fullPath(),
    },
    {
      condition: () => true,
      path: navigation.settings.folders.customFields.fullPath(),
    },
  ]

  const redirectLink = () => {
    const route = routes.find(({ condition }) => condition())
    return route?.path ?? navigation.settings.folders.customFields.fullPath()
  }

  if (loading) return <Loading />

  return <Navigate replace to={redirectLink()} />
}

export default RedirectToFolderSettingsPage
